export const sliderItemWidth = 340;
export const sliderSpace = 40;
